import React, { PureComponent } from 'react'

// local components
import InventoryItem from './InventoryItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

const InventoryItemEditable = EditableHOCWrapper(InventoryItem)

class InventoryItemContainer extends PureComponent {
  onSave = (data, afterOnSave) => {
    this.props.onInventoryUpdate(data, afterOnSave)
  }

  render() {
    const {
      inventory = {},
      lastModified = null,
      defaultEditMode = false,
      onCancel,
      onDelete,
      regions = [],
      companyFeatures,
      complianceType,
      complianceRoomOptions,
      isComplianceRoomsEnabled = false,
    } = this.props

    return (
      <InventoryItemEditable
        complianceRoomOptions={complianceRoomOptions}
        complianceType={complianceType}
        dataToEdit={inventory}
        onSave={this.onSave}
        lastModified={lastModified}
        defaultEditMode={defaultEditMode}
        isComplianceRoomsEnabled={isComplianceRoomsEnabled}
        onCancel={onCancel}
        onDelete={onDelete}
        regions={regions}
        companyFeatures={companyFeatures}
      />
    )
  }
}

export default InventoryItemContainer



// WEBPACK FOOTER //
// ./src/components/Inventory/InventoryItemContainer.js